__turbopack_context__.v({
  "body": "index-module-scss-module__tetJRW__body",
  "buttonWrapper": "index-module-scss-module__tetJRW__buttonWrapper",
  "description": "index-module-scss-module__tetJRW__description",
  "title": "index-module-scss-module__tetJRW__title",
});
